import styled, { css } from "styled-components";
import theme from "styled-theming";

const inputClient = theme("badgesLayout", {
  contained: css`
    background: #fff;
    padding: 8px;
    margin: 5px auto 10px auto;
    border-radius: 0;
  `
});

export const Label = styled.label`
  display: block;
  text-align: left;
  font-weight: bold;
  margin: 5px auto;
  font-size: 12px;
  color: ${props => props.theme.themeGlobal.main};
`;

export const Input = styled.input`
  display: block;
  width: 100%;
  min-height: 30px;
  margin: 5px 0;
  border-radius: 4px;
  border: 1px solid #aaa;
  line-height: 118%;
  color: ${props => props.theme.themeGlobal.textColor};
  ${inputClient};
`;

export const Textarea = styled.textarea`
  display: block;
  width: 100%;
  height: 100px;
  margin: 5px 0;
  border-radius: 4px;
  border: 1px solid #aaa;
  background: #fff;
  @media only screen and (max-width: 1024px) and (orientation: landscape) {
    max-height: 60px;
  }
`;

export const Required = styled.div`
  color: #82134f;
  font-weight: bold;
  margin: 5px auto;
  font-size: 12px;
`;
